import {useSelector} from 'react-redux';
import {matrixSelector} from '../../slices/matrixSlice';
import PriceDropdown from './PriceDropdown';
import PriceList from './PriceList';

const Price = () => {
  const {priceListType} = useSelector(matrixSelector);

  if (priceListType !== 'table') {
    return <PriceDropdown />;
  }

  return <PriceList />;
};

export default Price;
